<template>
  <b-row>
    <b-col
      cols="12"
      lg="6"
      class="col-print-6"
      v-if="
        existeNivel('PARVULARIA') ||
          existeNivel('BASICA') ||
          existeNivel('MEDIA')
      "
    >
      <table class="table text-black-50 mb-0">
        <thead>
          <tr>
            <th
              scope="col"
              colspan="2"
              class="text-morado-claro border-top-0 px-0 gilmer h6 text-center text-lg-left"
            >
              Información de pago
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="existeNivel('PARVULARIA')">
            <td class="text-morado-claro bg-morado-claro">Parvularia</td>
            <td
              class="text-morado-claro font-weight-bold bg-morado-claro text-center"
            >
              {{ valorParvularia }}
            </td>
          </tr>
          <tr v-else>
            <td class="text-morado-claro bg-morado-claro">Parvularia</td>
            <td
              class="text-morado-claro font-weight-bold bg-morado-claro text-center"
            >
              -
            </td>
          </tr>
          <tr v-if="existeNivel('BASICA')">
            <td class="text-morado-claro bg-morado-claro">Básica</td>
            <td
              class="text-morado-claro font-weight-bold bg-morado-claro text-center"
            >
              {{ valorBasica }}
            </td>
          </tr>
          <tr v-else>
            <td class="bg-morado-claro text-morado-claro">Básica</td>
            <td
              class="text-morado-claro font-weight-bold bg-morado-claro text-center"
            >
              -
            </td>
          </tr>
          <tr v-if="existeNivel('MEDIA')">
            <td class="bg-morado-claro text-morado-claro">Media</td>
            <td
              class="text-morado-claro font-weight-bold bg-morado-claro text-center"
            >
              {{ valorMedia }}
            </td>
          </tr>
          <tr v-else>
            <td class="bg-morado-claro text-morado-claro">Media</td>
            <td
              class="text-morado-claro font-weight-bold bg-morado-claro text-center"
            >
              -
            </td>
          </tr>
        </tbody>
      </table>
    </b-col>
    <b-col cols="12" lg="6" class="col-print-6">
      <table class="table text-black-50 mt-3 mt-lg-0 mb-0">
        <thead>
          <tr>
            <th
              scope="col"
              colspan="2"
              class="text-morado-claro border-top-0 px-0 gilmer h6 text-center text-lg-left"
            >
              Datos y estadísticas
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="bg-morado-claro text-morado-claro ">
              Alumnos matriculados
            </td>
            <td
              class="text-morado-claro font-weight-bold bg-morado-claro text-center"
            >
              {{ alumnosMatriculados }}
            </td>
          </tr>
          <tr>
            <td class="bg-morado-claro text-morado-claro ">
              Promedio alumnos por curso
            </td>
            <td
              class="text-morado-claro font-weight-bold bg-morado-claro text-center"
            >
              {{ promedioAlumnos }}
            </td>
          </tr>
          <tr>
            <td class="bg-morado-claro text-morado-claro ">
              Cantidad de docentes
            </td>
            <td
              class="text-morado-claro font-weight-bold bg-morado-claro text-center"
            >
              {{ docentes }}
            </td>
          </tr>
        </tbody>
      </table>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    alumnosMatriculados: {
      type: Number,
      default: 0,
      required: true
    },
    promedioAlumnos: {
      type: Number,
      default: 0,
      required: true
    },
    docentes: {
      type: Number,
      default: 0,
      required: true
    },
    sedes: {
      type: Array,
      required: true
    }
  },
  computed: {
    valorParvularia() {
      return this.glosaPrecioPorNivel(this.filtroNivelPorGlosa("PARVULARIA"));
    },
    valorBasica() {
      return this.glosaPrecioPorNivel(this.filtroNivelPorGlosa("BASICA"));
    },
    valorMedia() {
      return this.glosaPrecioPorNivel(this.filtroNivelPorGlosa("MEDIA"));
    }
  },
  methods: {
    valorMaximo: function(niveles) {
      let monto = 0;
      niveles = niveles.filter(n => n.copago != null);
      if (niveles.length > 0) {
        let montoSede = niveles.reduce((prev, actual) => {
          return prev.copago.valorCuota * prev.copago.numeroCuotas >
            actual.copago.valorCuota * actual.copago.numeroCuotas
            ? prev
            : actual;
        });
        if (
          montoSede.copago.valorCuota * montoSede.copago.numeroCuotas >=
          monto
        ) {
          monto = montoSede.copago.valorCuota * montoSede.copago.numeroCuotas;
          return { monto, montoSede };
        } else {
          return {
            monto: 0,
            montoSede: {
              copago: {
                valorCuota: 0,
                numeroCuotas: 0
              }
            }
          };
        }
      }

      return null;
    },
    existeNivel: function(glosa) {
      let niveles = this.filtroNivelPorGlosa(glosa, this.sedes);
      if (niveles.length > 0) {
        return true;
      }
      return false;
    },
    filtroNivelPorGlosa: function(glosa) {
      if (this.sedes.length > 0) {
        let niveles = this.sedes.flatMap(s => s.niveles).filter(n => n != null);
        if (niveles.length > 0) {
          return niveles.filter(n => n.glosaGrupoPago.includes(glosa));
        }
      }
      return [];
    },
    formatoInteger: function(num) {
      let numero = num + "";
      numero = numero.replace(/\D/g, "");
      let str = this.invertir(numero);
      return this.invertir(str.match(/.{1,3}/g).join("."));
    },
    invertir: function(str) {
      let inv = "";
      for (let i = str.length - 1; i >= 0; i--) {
        inv += str[i];
      }
      return inv;
    },
    glosaPrecioPorNivel(niveles) {
      let respuesta = this.valorMaximo(niveles);
      if (respuesta) {
        let objeto = respuesta.montoSede;
        return objeto &&
          objeto.copago.numeroCuotas * objeto.copago.valorCuota > 0
          ? objeto.copago.numeroCuotas +
              " cuotas de $" +
              this.formatoInteger(objeto.copago.valorCuota)
          : "Gratuito";
      }
      return "Sin información";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ficha/izquierda/PagosDatosEstadisticas.vue